module.exports = __webpack_public_path__ + "images/emoji/email.61c336da1178f433fdc3.png";